/**
 * Every RTCPeerConnection the page makes, for the call's diagnostics.
 *
 * webrtc-wrapper keeps its peer connections to itself, and the diagnostics
 * must not change how it connects. So the global constructor is replaced,
 * once, with a subclass that only notes each instance; the wrapper's
 * `new RTCPeerConnection(...)` reads the global when it runs, after this.
 * Closed connections drop out on the next read.
 */
const made = new Set<RTCPeerConnection>();
let installed = false;

export function installRtcRegistry(): void {
  if (installed || typeof window === 'undefined' || typeof window.RTCPeerConnection !== 'function') return;
  installed = true;
  const Native = window.RTCPeerConnection;
  class Noted extends Native {
    constructor(config?: RTCConfiguration) {
      super(config);
      made.add(this);
    }
  }
  window.RTCPeerConnection = Noted as typeof RTCPeerConnection;
}

/** The connections still open. */
export function openPeerConnections(): RTCPeerConnection[] {
  for (const pc of made) if (pc.connectionState === 'closed' || pc.signalingState === 'closed') made.delete(pc);
  return [...made];
}
